import { useCallback } from 'react';

// eslint-disable-next-line no-restricted-imports
import { useFileGetDownloadLinkByIdLazyQuery } from 'api/generated/graphql';
import { useError } from 'api/helpers';

export const useFileDownload = () => {
  const [handle, { data, loading, error: apolloError }] =
    useFileGetDownloadLinkByIdLazyQuery();

  const error = useError(apolloError);

  const getFileLink = useCallback(
    async (fileId: string) => {
      const res = await handle({ variables: { id: fileId } });
      return res.data?.fileGetDownloadLinkById?.url;
    },
    [handle]
  );

  return {
    data,
    loading,
    error,
    getFileLink,
  };
};
